// extracted by mini-css-extract-plugin
module.exports = {"slider":"ToggleButton_slider__JWyv4","switch":"ToggleButton_switch__OC_V5","switchInput":"ToggleButton_switchInput__Slkb4"};